module.exports = __webpack_public_path__ + "media/img/horizontal-logo-small-79b6ac850a9014a56a747ed40a476b7b.png";